$(() => {

	/**
	 * Acceptance nice checkbox
	 * @type {*|jQuery|HTMLElement}
	 */

	const $checkbox = $('#acceptance');

	if (!$checkbox.length) {
		return;
	}

	// console.log($checkbox.prop('checked'));

	const handleChecked = () => {
		if ($checkbox.prop('checked')) {
			$checkbox.parents('.wpcf7-acceptance').addClass('checked');
		} else {
			$checkbox.parents('.wpcf7-acceptance').removeClass('checked');
		}
	};

	document.addEventListener('wpcf7mailsent', handleChecked, false);
	document.addEventListener('wpcf7spam', handleChecked, false);
	document.addEventListener('wpcf7mailfailed', handleChecked, false);

	$(document).on('change', '#acceptance', event => {
		// console.log(event.currentTarget);

		$(event.currentTarget).parents('.wpcf7-acceptance').toggleClass('checked');
	});

	$(document).on('click', '.wpcf7-acceptance', function() {});
});



// WEBPACK FOOTER //
// ./assets/scripts/acceptance.js